export default __webpack_public_path__ + "static/SALUD_S2-397ba364b7711795852fa0d15642f210.png";